var map = {
	"./hotstyleshow1.jpg": "90fc",
	"./hotstyleshow2.jpg": "d06e",
	"./hotstyleshow3.jpg": "0c2e",
	"./hotstyleshow4.jpg": "452a",
	"./hotstyleshow5.jpg": "5451",
	"./hotstyleshow6.jpg": "9ad9",
	"./hotstyleshow7.jpg": "da72",
	"./hotstyleshow8.jpg": "fc8d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1c4";